"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exportToPdf;
var _jspdf = require("jspdf");
require("jspdf-autotable");
var _pdfExportFormatter = require("./pdfExportFormatter");
// excell export tarafı ile eşit olması için pdfExport içinden dışarıya açıldı.

function getTitle(col) {
  return typeof col.pdfTitle === 'string' ? col.pdfTitle : col.title;
}
function prepareHeader(columns) {
  return columns.map(function (col) {
    return getTitle(col);
  });
}
function getValue(row, col) {
  var value = row[col.dataIndex];
  if (typeof col.pdfRender === 'function') {
    var parsedValue = col.pdfRender(value, row);
    if (parsedValue !== null && parsedValue !== void 0 && parsedValue.children) {
      return String(parsedValue.children);
    }
    return parsedValue ? String(parsedValue) : '';
  }
  if (_pdfExportFormatter.pdfExportFormatter[col.dataIndex]) {
    return _pdfExportFormatter.pdfExportFormatter[col.dataIndex](value);
  }
  return value !== undefined && value !== null ? String(value) : '';
}
function prepareBody(columns, data) {
  return data.map(function (row) {
    return columns.map(function (col) {
      return getValue(row, col);
    });
  });
}
function exportToPdf(options) {
  var columns = options.columns,
    _options$data = options.data,
    data = _options$data === void 0 ? [] : _options$data,
    _options$filename = options.filename,
    filename = _options$filename === void 0 ? 'export' : _options$filename;
  var doc = new _jspdf.jsPDF();
  var header = prepareHeader(columns);
  var body = prepareBody(columns, data);
  doc.autoTable({
    head: [header],
    body: body
  });
  doc.save("".concat(filename, ".pdf"));
}